module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-sl.f5c45fdd.png";